import { ClientResources, PersonAliasDto, PersonDto } from '@app/api2/api';
import * as Yup from 'yup';
import { searchMeta } from '../../Search/components/query-builder/Meta';

export type AdditionalTypeMembers = Pick<PersonDto, 'id' | 'ethnicityId' | 'pobCityId' | 'pobCountryId' | 'pobStateId' | 'fatherLastName' | 'motherLastName' | 'aliases'>;

export const AdditionalSchema: (t: ClientResources) => Yup.SchemaOf<AdditionalTypeMembers> = (t) => Yup.object({
    id: Yup.number().optional().meta(searchMeta(false)),
    ethnicityId: Yup.number().optional().nullable().label(t.metadata.ethnicityLabel || 'Ethnicity'),
    pobCityId: Yup.number().optional().nullable().label(t.metadata.placeOfBirthCityLabel || 'Place of Birth (City)'),
    pobStateId: Yup.number().optional().nullable().label(t.metadata.placeOfBirthStateLabel || 'Place of Birth (State)'),
    pobCountryId: Yup.number().optional().nullable().label(t.metadata.placeOfBirthCountryLabel || 'Place of Birth (Country)'),
    fatherLastName: Yup.string().max(80).label(t.metadata.fatherLastNameLabel || 'Father Last Name'),
    motherLastName: Yup.string().max(80).label(t.metadata.motherLastNameLabel || 'Mother Last Name'),
    aliases: Yup.array().of(
        Yup.object().shape({
            aliasName: Yup.string().label(t.metadata.aliasNameLabel || 'Alias Name').max(180).required(),
            personId: Yup.number().optional().meta(searchMeta(false)),
            id: Yup.number().optional().nullable().meta(searchMeta(false)),
        }) as Yup.SchemaOf<PersonAliasDto>
    ).label(t.metadata.aliasesLabel || 'Aliases'),
});

type AdditionalTypeMembersObject = Record<(keyof AdditionalTypeMembers), undefined>;

const additionalDefProperties: AdditionalTypeMembersObject = {
    id: undefined,
    ethnicityId: undefined,
    pobCityId: undefined,
    pobCountryId: undefined,
    pobStateId: undefined,
    fatherLastName: undefined,
    motherLastName: undefined,
    aliases: undefined,
};

export const ALL_ADDITIONAL_PROPERTIES = Object.keys(additionalDefProperties) as (keyof AdditionalTypeMembers)[];
